import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "button"];

  static values = {
    currency: String
  };

  declare currencyValue: string;
  declare readonly hasCurrencyValue: boolean;

  declare readonly hasInputTarget: boolean;
  declare readonly inputTarget: HTMLInputElement;

  declare readonly hasButtonTarget: boolean;
  declare readonly buttonTargets: [HTMLButtonElement];

  connect() {
    this.updateButtonsFromInput = this.updateButtonsFromInput.bind(this);
    this.updateButtonsFromInput();
  }

  updateButtonsFromInput() {
    this.buttonTargets.forEach((button) => {
      if (this.currencyValue === button.dataset.value) {
        button.classList.remove("btn_outlined");
      } else {
        button.classList.add("btn_outlined");
      }
    });
  }

  currencyValueChanged() {
    if (this.currencyValue !== this.inputTarget.value) {
      this.updateButtonsFromInput();
      this.inputTarget.value = this.currencyValue;
    }
  }

  handleChange(e) {
    e.preventDefault();
    this.currencyValue = e.target.dataset.value;
  }
}
